import { Component, ViewEncapsulation } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { Worker } from '../../workers/_types/worker';
import moment from 'moment';
import { WorkerBillableItemLine } from '../../workers/_types/worker-billable-item-line';
import { WorkerBillableItemLinesService } from '../../workers/_services/workers-billable-item-lines.service';
import { WorkersService } from '../../workers/_services/workers.service';
import { WorkerBillableItemsGeneratorComponent } from './worker-billable-items-lines-generator/worker-billable-items-lines-generator.component';
import { DialogService } from 'primeng/dynamicdialog';
import { NumberUtilsService } from 'src/app/core/services/number-utils.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { Message } from 'sip.js';

@Component({
    selector: 'app-transactions-workers-billable-items-lines',
    templateUrl: './transactions-workers-billable-items-lines.component.html',
    styleUrls: ['./transactions-workers-billable-items-lines.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'list-page' },
    standalone: false
})
export class TransactionsWorkerBillableItemsComponent {

  public loading: boolean = false;
  public type!: string;

  public filters: any = {
    workerId: new Filter(FilterOperation.equals, 'workerId', ''),
    dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date', '', moment().startOf('month').toDate()),
  };

  public workerOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.workerId, type: 'select', label: 'Operario', options: this.workerOptions, filterable: true, base: true },
    { filter: this.filters.dateFrom, type: 'date', label: 'Desde', base: true }
  ];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public workerBillableItemLines: WorkerBillableItemLine[] = [];
  public selectedLine: WorkerBillableItemLine | null = null;
  public displayInfoDialog: boolean = false;

  public lastGridEvent: any;
  public totalRecords:number = 0;
  public workers: Worker[] = [];

  constructor(
    private dialogService: DialogService,
    private topbarService: TopbarService,
    private workerBillableItemLinesService: WorkerBillableItemLinesService,
    private workersService: WorkersService,
    private numberUtils: NumberUtilsService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) {
    this.allowWrite = true;
    this.allowDelete = true;
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Conceptos facturables de operarios");
    setTimeout(() => {
      this.topbarService.addAction("Generar conceptos", "",true, () => {
        this.showGenerateBillableItemsDialog();
      });
    });
    this.loadWorkers(null);
    this.loadWorkerOptions();
    this.loadWorkerBillableItemLines(null);

  }
  private async loadWorkerOptions() {
    let response = await firstValueFrom(this.workersService.all({ sort: ['name'], page: { size: 5000 }, fields: { workers: 'name' } }));
    this.workerOptions.length = 0;
    this.workerOptions.push(...response.data.map((w: any) => ({ label: w.name, value: w.id })));
  }

  /*

  clearFilters() {
    this.filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', ''),
      dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date', '', moment().startOf('month').toDate()),
    };
    this.loadWorkerBillableItemLines(null);
  }
  */

  async loadWorkers(event: any){
    let text = "";       
    if (event != null) text = event.filter; 
    
    let filters: any = { };
    if(text != "" && text.length >= 3) filters.name = new Filter(FilterOperation.contains, 'name', "", text);
    //creamos filtros
    let params: IParamsCollection = {
      sort: ['name'],
      page: { size: 1000 },
      fields: { workers: 'name' }
    }
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.workersService.all(params));
    this.workers = response.data;
  }

  async loadWorkerBillableItemLines($event:any){
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      sort: ['-date'],
      include: ['worker', 'transaction.transactionType'],
      filter: FilterBuilder.fromObject(this.filters).build(),
      fields: {
        workerBillableItemLines: 'date,description,quantity,price,taxPercent,subtotal,total,workerId,worker,transactionId,transaction',
        workers: 'name',
        transactions: 'code,date,transactionType',
        transactionTypes: 'code,name'
      }
    }

    //paginacion
    if(typeof $event == "undefined" || $event == null){
      params.page = { number: 1, size: 25 };      
    }else{
      params.page = { number: $event.first + 1, size: $event.rows };
      if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];    
    }  
    
    let response = await firstValueFrom(this.workerBillableItemLinesService.all(params));
    this.workerBillableItemLines = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  async showGenerateBillableItemsDialog(){
    var ref = this.dialogService.open(WorkerBillableItemsGeneratorComponent, {
      closable: true,
      modal: true,
      header: 'Generar conceptos facturables',
      width: '80%',
      data: {
      }
    });
    ref.onClose.subscribe(result => {
      this.loadWorkerBillableItemLines(this.lastGridEvent);
    });
  }

  async delete(line: WorkerBillableItemLine){
    //comprobamos que no esté asociado a una transacción facturada
    if(line.transaction?.netSuiteId){
      this.messageService.add({severity:'error', summary: 'Error', detail: 'No se puede eliminar porque ya está asociado a una factura.' });
      return;
    }
    this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el concepto facturable?",
        header: "Eliminar transacción",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          await firstValueFrom(this.workerBillableItemLinesService.delete(line.id));
          this.loadWorkerBillableItemLines(this.lastGridEvent); 
        }
        ,reject: () => {
        }
    });
  }

  async info(line: WorkerBillableItemLine){
    //abrimos dialogo con la información del concepto facturable
    let fullLine = await firstValueFrom(this.workerBillableItemLinesService.get(line.id!, {
      include: ['worker', 'transaction.transactionType']
    }));
    this.selectedLine = fullLine;
    this.displayInfoDialog = true;
  }

}
